<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="40px" viewBox="0 0 32 32">
    <path
      d="M23.51,17.02c.02-2.53,1.13-4.44,3.34-5.83-1.24-1.77-3.11-2.74-5.58-2.93-2.34-.19-4.9,1.36-5.83,1.36-.99,0-3.25-1.29-5.03-1.29C6.73,8.39,2.83,11.26,2.83,17.1c0,1.73.32,3.51.95,5.35.84,2.42,3.88,8.35,7.05,8.25,1.66-.04,2.83-1.18,4.99-1.18s3.19,1.18,5.04,1.18c3.2-.05,5.95-5.44,6.75-7.87-4.29-2.02-4.1-5.73-4.1-5.81ZM19.83,5.96c1.78-2.11,1.61-4.03,1.56-4.72-1.57.09-3.38,1.07-4.41,2.27-1.14,1.29-1.81,2.88-1.66,4.68,1.69.13,3.24-.74,4.52-2.23Z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "AppleIcon",
};
</script>

<style lang="scss" scoped></style>
